import React, { memo, useMemo } from 'react';
import { FaExclamation } from 'react-icons/fa';
import { formatPrice } from '../../../../utils/formatter';
import CheckMark from '../../../shared/status/CheckMark';
import Row from '../../../shared/table/Row';
import SelectableRow from '../../../shared/table/SelectableRow';
import Table from '../../../shared/table/Table';

const SplitPartTable = ({ visitParts, selectedParts, allSelected, onVisitPartSelect, onSelectAll }) => {
  const tableRows = useMemo(
    () =>
      visitParts.map((visitPart, i) => {
        const isSelected = selectedParts.includes(visitPart.id);
        return (
          <SelectableRow key={i} onClick={() => onVisitPartSelect(visitPart)}>
            <Row>
              <CheckMark isChecked={isSelected} />
            </Row>
            <Row>
              <div className="flex gap-1 items-center">
                {visitPart.isCritical && <FaExclamation size={14} className="text-contrast1" />}
                {visitPart.part.name}
              </div>
            </Row>
            <Row children={formatPrice(visitPart.price)} />
          </SelectableRow>
        );
      }),
    [visitParts, selectedParts, onVisitPartSelect],
  );

  return <Table columns={columns({ onSelectAll, allSelected })} data={tableRows} />;
};

function columns({ onSelectAll, allSelected }) {
  return [
    { object: <CheckMark isChecked={allSelected} onClick={onSelectAll} />, className: 'w-[5%]' },
    { name: 'Назва', className: 'w-[85%]' },
    { name: 'Ціна', className: 'w-[10%]' },
  ];
}

export default memo(SplitPartTable);
